import { Card } from '~/components';
import { clsx } from '~/styles/utils';

import {
  animatePulseStyle,
  footerStyle,
  headerStyle,
  skeletonFooterStyle,
  skeletonHeaderStyle,
  skeletonLogoStyle,
  wrapperStyle,
} from './CommunityProfileCard.css';

export type Props = {
  animate?: boolean;
};

export const CommunityProfileCardSkeleton = ({ animate = false }: Props) => {
  return (
    <Card.Group className={clsx(wrapperStyle, animate && animatePulseStyle)}>
      <Card.Root className={clsx(skeletonHeaderStyle, headerStyle)} variant="primary-light">
        <div className={skeletonLogoStyle} />
      </Card.Root>

      <Card.Root className={clsx(skeletonFooterStyle, footerStyle)} />
    </Card.Group>
  );
};
